module.exports = "https://coursera_assets.s3.amazonaws.com/images/8f0f9bd2b409eef47cb3b2c57bb222b0.png";